export const STATUS_ID_RECIEVED = '5677EA07-6671-4DE8-921F-8743D6C9903C'
export const STATUS_ID_CANCELED = 'FF0D452C-672E-4F98-9E4D-53E9B313D3EB'
export const STATUS_ID_SCORE = '324B1281-7735-A6DA-46FD-7241A537A3C9'
export const STATUS_ID_CONFIRMED = 'AA4B0E81-6623-477D-882C-C955541A4BD8'

export const STATUSES_TO_CHANGE_FINAL_SCORE = [
	'CB86736A-02F2-4B9F-9DE8-946791D6FBDB',
	'23FC9A19-462F-406D-8D18-DE13A6A6B0E0',
	'18F93418-06F1-4827-9F94-DB0D9CEC6DC2'
]